import { render, staticRenderFns } from "./ButtonText.vue?vue&type=template&id=5ea49e93"
import script from "./ButtonText.vue?vue&type=script&lang=js"
export * from "./ButtonText.vue?vue&type=script&lang=js"
import style0 from "./ButtonText.vue?vue&type=style&index=0&id=5ea49e93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports